import {
    getGoHighway,
    getRMISSetup,
    inviteRMIS,
    refreshRMIS,
    requiredRMIS, updateGoHighway,
    updateRMISSetup,
} from './rmis.action';
export {rmisReducer} from './rmis.reducer';
export {watchRmis} from './rmis.saga';

export const rmisActions = {
    /** Rmis Settings */
    inviteRMIS,
    refreshRMIS,
    getRMISSetup,
    updateRMISSetup,
    requiredRMIS,
    /** End */

    /** Go Highway */
    getGoHighway,
    updateGoHighway,
    /** End */
}

